import { Link } from 'react-router-dom'
import { PlusIcon, ArrowUpRightIcon } from '@heroicons/react/24/outline'

import { stripMarkdown } from '@helpers/format'
import { getTutorVisualStyle } from '@helpers/courseUtils'
import Image from '@components/Image'
import { Button } from '@components/ui/button'
import { durationInWords } from '@helpers/format'

const TutorCard = ({ tutorId = '', name, description, imageUrl, assignedAt, classroomId, classroomName, url, children, knowledgeBaseEnabled, suggestionsEnabled }) => {
  const formattedDescription = stripMarkdown(description)
  const { emoji, gradientFrom, gradientTo } = getTutorVisualStyle(tutorId)

  return (
    <div className={"font-dm-sans grow flex flex-col sm:flex-row gap-3 border p-5 rounded-lg bg-background"}>

      <Choose>
        <When condition={imageUrl}>
          <Image
            className='size-24 shrink-0 rounded-sm bg-gray-200 object-cover'
            src={imageUrl}
            placeholder={<div className='size-24 shrink-0 rounded-sm bg-gray-200'></div>}
          />
        </When>
        <Otherwise>
          <div
            className='size-24 shrink-0 rounded-sm flex items-center justify-center'
            style={{ background: `linear-gradient(135deg, ${gradientFrom}, ${gradientTo})` }}
          >
            <span className='text-3xl'>{emoji}</span>
          </div>
        </Otherwise>
      </Choose>

      <div className='flex flex-col gap-2'>
        <h2 className='text-sm font-semibold line-clamp-1'>{name}</h2>
        <If condition={formattedDescription?.length}>
          <p className='text-sm line-clamp-2 break-all'>{formattedDescription}</p>
        </If>
        <div className='text-xs text-muted-foreground flex gap-2 items-center'>
          <Link to={`/students/classrooms/${classroomId}`}>
            <Button size='sm' variant='outline' className='text-foreground'>
              <ArrowUpRightIcon className='size-3 mr-1 shrink-0 text-muted-foreground' />
              {classroomName}
            </Button>
          </Link>
          <span>•</span>
          <span>{durationInWords(assignedAt)}</span>
        </div>
        <div className='mt-2'>
          <Link to={url + '?new=true'}>
            <Button size='sm' variant='outline'>
              <PlusIcon className='size-4 mr-1 shrink-0 text-muted-foreground' />
              New chat
            </Button>
          </Link>
        </div>
        {children}
      </div>
    </div>
  )
}

export default TutorCard
